<template>
  <div v-if="visible" class="tooltip" :style="styleObject">
    <slot>{{ content }}</slot>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    content: {
      type: String,
      default: ''
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObject() {
      return {
        position: 'absolute',
        left: this.x + 'px',
        top: this.y + 'px',
        zIndex: 1000
      };
    }
  }
};
</script>

<style scoped>
.tooltip {
  background: #222;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  pointer-events: none;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  opacity: 100;
}
</style>
